import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export interface RadioInputProps {
  label?: string;
  values?: any[];
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<any>) => void;
  classes?: string;
}

function RadioInput(props: RadioInputProps) {
  return (
    <FormControl>
      {props.label && (
        <FormLabel id="demo-row-radio-buttons-group-label">
          {props.label}
        </FormLabel>
      )}
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        {props.values &&
          props.values.map((radio) => (
            <FormControlLabel
              key={radio.label}
              value={radio.value}
              control={<Radio />}
              label={radio.label}
              disabled={radio.disabled}
              checked={radio.isSelected}
              onChange={props.onChange}
              className={`radio-btn ${props.classes}`}
              data-testid={`radio-label-${radio.value}`}
            />
          ))}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioInput;
